import { render, staticRenderFns } from "./ContactThanks.vue?vue&type=template&id=cd4c395c&scoped=true&"
import script from "./ContactThanks.vue?vue&type=script&lang=js&"
export * from "./ContactThanks.vue?vue&type=script&lang=js&"
import style0 from "./ContactThanks.vue?vue&type=style&index=0&id=cd4c395c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c395c",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/contact_thanks.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fcommons%2FContactThanks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports